/* eslint-disable react/display-name */
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { TimesheetLabel } from 'modules/timesheet-labels/labelSchema';
import LabelFacetDetails from '../LabelFacetDetails';
import {
  DetailsControlProps,
  SearchFacetType,
  SuggestionItemProp
} from '../type';
import { LabelOptionItem } from '../OptionItem';
import { useOefLabelSearch } from './hooks/useOefLabelSearch';
import makeCriteriaProvider from './makeCriteriaProvider';

export const getDetailsControl = (
  label: TimesheetLabel,
  onDropdownValueChange?: (mappedValue: any, label: any) => void,
  isDisable?: (label: any) => boolean,
  settingInitialDopDownValue?: (label: any, setSelected: any) => void
): React.FC<DetailsControlProps> => ({
  selected,
  setSelected
}: DetailsControlProps) => {
  const { options, loading, searchHandler, hasMore } = useOefLabelSearch();

  return (
    <LabelFacetDetails
      selected={selected}
      setSelected={setSelected}
      options={options}
      loading={loading}
      searchHandler={searchHandler}
      label={label}
      hasMore={hasMore}
      onDropdownValueChange={onDropdownValueChange}
      isDisable={isDisable}
      settingInitialDopDownValue={settingInitialDopDownValue}
    />
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(0)
  }
}));

const SuggestionItem: React.FC<SuggestionItemProp> = ({
  option
}: SuggestionItemProp) => {
  const classes = useStyles();
  return (
    <LabelOptionItem
      testId={option.id}
      value={option.label}
      classes={classes}
    />
  );
};

export const getOefFacet = (
  label: TimesheetLabel,
  onDropdownValueChange?: (mappedValue: any, label: any) => void,
  isDisable?: (label: any) => boolean,
  settingInitialDopDownValue?: (label: any, setSelected: any) => void
): SearchFacetType => {
  return {
    makeCriteriaProvider: makeCriteriaProvider(label),
    tag: `${label.name.toLowerCase().replaceAll(' ', '-')}:`,
    DetailsControl: getDetailsControl(
      label,
      onDropdownValueChange,
      isDisable,
      settingInitialDopDownValue
    ),
    SuggestionItem: SuggestionItem
  };
};

export default getOefFacet;
